/* eslint-disable */
import { useMemo, useRef, useState, useEffect } from "react";
import JoditEditor from "jodit-react";
import { ArticleOutlineJoditGlobalStyles, ArticleOutlineWrapper } from "./css";
import { useTheme } from "@mui/material";

const StepperArticleOutlineBody = ({ formData, updateForm }) => {
  const theme = useTheme();
  const editor = useRef(null);

  const [content, setContent] = useState(formData.outlineHtml || "");

  useEffect(() => {
    if (formData.outlineHtml) {
      setContent(formData.outlineHtml);
    }
  }, [formData.outlineHtml]);

  const config = useMemo(
    () => ({
      preset: "custom",
      readonly: false,
      toolbar: true,
      toolbarAdaptive: false,
      buttons: ["undo", "redo", "paragraph"],
      buttonsMD: ["undo", "redo", "paragraph"],
      buttonsSM: ["undo", "redo", "paragraph"],
      buttonsXS: ["undo", "redo", "paragraph"],
      sourceEditor: "area",
      removeButtons: "textColor,background",
    }),
    [],
  );

  return (
    <ArticleOutlineWrapper>
      <JoditEditor
        ref={editor}
        config={config}
        value={content}
        onBlur={newContent => {
          setContent(newContent);
          updateForm("outlineHtml", newContent);
        }}
      />
      <ArticleOutlineJoditGlobalStyles theme={theme} />
    </ArticleOutlineWrapper>
  );
};

export default StepperArticleOutlineBody;
